export const FETCH_UPLOAD_FOLDER_REQUEST = 'FETCH_UPLOAD_FOLDER_REQUEST'
export const FETCH_UPLOAD_FOLDER_SUCCESS = 'FETCH_UPLOAD_FOLDER_SUCCESS'
export const FETCH_UPLOAD_FOLDER_FALUIRE = 'FETCH_UPLOAD_FOLDER_FALUIRE'
